'use client'

import { useLocale } from '@/components/LocaleContext'
import { getLocalizedTranslationData } from '@/utilities/translationsData'

import { DiamondIcon } from './DiamondIcon'
import type { ProductCarouselItem } from './ProductCarousel'
import { ProductCarousel } from './ProductCarousel'
import { SectionPreHeader } from './SectionPreHeader'
import { ViewProjectsButton } from './ViewProjectsButton'

export function ProductsSection({ products }: { products: ProductCarouselItem[] }) {
  const { locale, translatedData } = useLocale()
  const c = translatedData?.common
  const st = getLocalizedTranslationData((locale as AppLocale) ?? 'en').common
  const ourProducts = c?.our_products ?? st?.our_products ?? 'Our Products'
  const line1 =
    c?.products_headline_line1 ?? st?.products_headline_line1 ?? 'Engineered filtration solutions'
  const line2 =
    c?.products_headline_line2 ?? st?.products_headline_line2 ?? 'Across every application'
  const isAr = locale === 'ar'
  const preCaps = isAr ? '' : 'uppercase'
  const h2Caps = isAr ? '' : 'uppercase'

  return (
    <section
      className="overflow-x-hidden bg-[#F9F9F9] py-10 max-[480px]:py-8 md:py-20 lg:py-24"
      aria-labelledby="products-heading"
      dir={locale == 'ar' ? 'rtl' : 'ltr'}
    >
      <div className="mx-auto w-full min-w-0 max-w-7xl px-4 max-[400px]:px-3 sm:px-6 lg:px-8 text-left mt-12 max-[480px]:mt-8 min-[900px]:mt-16 lg:mt-[70px] overflow-x-hidden">
        <SectionPreHeader
          icon={<DiamondIcon size={15} />}
          className={`mb-4 max-[480px]:mb-5 md:mb-7 !text-[17px] tracking-[1px] ${preCaps}`.trim()}
        >
          {ourProducts}
        </SectionPreHeader>
        <h2
          id="products-heading"
          className={`font-bebas-neue font-medium text-[#212121] text-3xl max-[400px]:text-2xl sm:text-5xl lg:text-[61.6px] leading-tight lg:leading-[68px] tracking-normal align-middle max-w-4xl mb-4 md:mb-[27px] break-words rtl:!text-right ${h2Caps}`.trim()}
        >
          {line1}
          <br />
          {line2}
        </h2>
        <ViewProjectsButton />
      </div>
      <div dir="ltr" className="mt-6 max-[480px]:mt-4 md:mt-10 w-full min-w-0 overflow-hidden">
        <ProductCarousel products={products} />
      </div>
    </section>
  )
}
